import { Switch, Route, useHistory, Redirect } from "react-router-dom";
import React from "react";
import HomeContainer from "./Home/Homecontainer";
import MovieContainer from "./Movies/MovieContainer";
import TvShowsContaner from "./TvShows/TvShowsContaner";
import About from "./About/About";
// import SubscriptionType from "./Subscription/SubscriptionType";
import SubscriptionForm from "./Subscription/SignUp";
import Login from "./Subscription/Login";
import PaymentType from "./Subscription/PaymentType.js";
import Payment from "./Subscription/Payment";
import PaymentResult from "./Subscription/PaymentDetails";

import MovieView from "./MovieView";
import TvShows from "./TvShows/TvShowsViews";

import PlayMovie from "./PlayMovie";
import ContinueViewPlay from "../components/Movies/ContinueViewPlay";
import PlayTvShows from "./TvShows/TvShowPlay";

import Search from "./Search";
import { useEffect, useState } from "react";
import axios from "axios";
import { API, username } from "../API";
import { isAutheticated } from "./auth/authhelper";
import Loader from "./loader/loader";
import TermCondition from "./TermCondition/TermCondition";
import Profile from "./Profile/Profile";
import PrivacyPolicy from "./PrivacyPolicy/PrivacyPolicy";
import ChangePassword from "./ChangePassword/ChangePassword";
import Contact from "./Contact/Contact";
import Cart from "./Cart/Cart";
import Api from "../Api/Api";
import Checkout from "./Checkout/Checkout";
import AllAddress from "./CartAddress/AllAddress";
import AddAddress from "./CartAddress/AddAddress";
import EditAddress from "./CartAddress/EditAddress";
import ShopPage from "./Shop/shop.js";
import NotFound from "./NotFound.js";
import CategoryContent from "./Home/CategoryContent.js";
import AudioUploader from "./Home/AudioUploader.js"
import SubchannelDetails from "./Home/SubchannelDetails.js";
import ForgotPassword from "./Subscription/ForgotPassword.js";
import SocomAdvisorDetails from "./Home/SocomAdvisorDetails.js";

const Router = () => {
  const [userData, setUserData] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [totalQuantity, setTotalQuantity] = useState(false);
  const [data, setData] = useState(false);
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  const { token } = isAutheticated();


  useEffect(() => {
    const getUser = async () => {
      // let existanceData = JSON.parse(localStorage.getItem("userData"));
      // if (existanceData) {
      //   // console.log(existanceData.userData)
      //   setUserData(JSON.parse(localStorage.getItem("userData")).userData);
      if (!token) {
        setUserData(false);
        return;
      } else {
        try {
          const response = await axios.get(`${API}/api/client`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          // console.log(response.data)

          //setUserData(response.data.data);
          // localStorage.setItem(
          //   "userData",
          //   JSON.stringify({
          //     userData: response.data.data
          //   })
          // );
          setUserData(response?.data?.data);
        } catch (err) {
          console.log(err);
          setUserData(false);
        }
      }
    };
    const getBanners = async () => {
      try {
        setLoading(true);

        const response = await axios.get(`${API}/api/banner/Webbanner`, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        console.log('ffffffffffffffff', response?.data)
        setBanners(response?.data?.data || []);
        setLoading(false);

      } catch (err) {
        console.log(err);
        setLoading(false);

      }
    };
    getUser();
    getBanners()
  }, [token]);

  useEffect(() => {
    const checkSubscription = async () => {
      if (!token) {
        setSubscription(false);
        return;
      } else {
        try {
          const response = await axios.get(
            `${API}/api/client/${username}/checkSubscription`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setSubscription(response?.data?.data);
        } catch (err) {
          console.log(err);
          setSubscription(false);
        }
      }
    };
    checkSubscription();
  }, [token]);

  const getCart = async () => {
    const data = await Api.getCart();
    setData(data);
    let sum = 0;
    for (let i = 0; i < data?.products?.length; i++) {
      sum += data?.products[i]?.quantity;
    }
    setTotalQuantity(sum);
  };
  useEffect(() => {
    getCart();
  }, []);

  //getting user profile
  const homeBanners = banners?.filter((banner) => banner?.category === "Home");
  const vediosBanners = banners?.filter((banner) => banner?.category === "Videos");

  const ShopBanners = banners?.filter((banner) => banner?.category === "Shop");
  // ✅ Optionally show loader
  if (loading) return <Loader />;

  return (
    <>
      {userData && userData._id && (
        <Cart totalQuantity={totalQuantity} data={data} getCart={getCart} />
      )}

      <Switch>
        <Route exact path="/paymentDetails">
          <PaymentResult />
        </Route>
        {/* <Route exact  path="/:username/movies" component={MovieContainer} /> */}
        <Route exact path="/videos">
          {subscription === null ? (
            <Loader />
          ) : (
            <MovieContainer banner={vediosBanners} />
          )}
        </Route>





        {/* <Route exact path="/videos">
          {userData && userData._id ? (
            subscription ? (
              <MovieContainer banner={vediosBanners} />
            ) : subscription === false ? (
              <PaymentType />
            ) : (
              <Loader />
            )
          ) : userData === false ? (
            <Login />
          ) : (
            <Loader />
          )}
        </Route> */}



        {/* <Route exact path="/movies">
          {userData?._id ? (
            subscription ? <MovieContainer /> : <PaymentType />
          ) : <Login />}
        </Route> */}

        <Route exact path="/tvshows">
          {userData && userData._id ? (
            subscription ? (
              <TvShowsContaner banner={banners} />
            ) : subscription === false ? (
              <PaymentType />
            ) : (
              <Loader />
            )
          ) : userData === false ? (
            <Login />
          ) : (
            <Loader />
          )}
        </Route>
        {/* <Route exact path="/tvshows">
          {userData?._id ? (
            subscription ? <TvShowsContaner /> : <PaymentType />
          ) : <Login />}
        </Route> */}

        <Route exact path="/shop">
          <ShopPage banner={ShopBanners} />
        </Route>
        {/* specific category */}
        <Route exact path="/net_channel/:channel_Name">
          <CategoryContent />
        </Route>
        {/* play routes */}
<Route exact path="/apex_channel/:advisor_Name">
          <SocomAdvisorDetails />
        </Route>

        {/* 1-segment URL (subchannel + video) */}

        <Route
          exact
          path="/:mainChannelName/channel/:subChannel/:slug([a-z0-9-]+-[a-f0-9]{24})/play"
        >
          {subscription === null ? <Loader /> : <PlayMovie getCart={getCart} />}
        </Route>

        {/* 2-segment URL (subchannel + video) */}
        <Route
          exact
          path="/:subChannel/:slug([a-z0-9-]+-[a-f0-9]{24})/play"
        >
          {subscription === null ? <Loader /> : <PlayMovie getCart={getCart} />}
        </Route>


        {/* <Route path="/subchannel/:subchannelSlug" component={SubchannelDetails} /> */}
        <Route exact path="/:mainChannel/channel/:subChannel/:slug">
          {subscription === null ? <Loader /> : <MovieView />}
        </Route>

        <Route exact path="/:subChannel/:slug([a-z0-9-]+-[a-f0-9]{24})">
          {subscription === null ? <Loader /> : <MovieView />}
        </Route>
        <Route exact path="/:mainChannel/channel/:subchannelSlug">
          <SubchannelDetails />
        </Route>




















        <Route exact path="/about">
          <About />
        </Route>

        <Route exact path="/profile">
          {userData?._id ? <Profile /> : <Login />}
        </Route>

        <Route exact path="/cartaddress">
          {userData?._id ? <AllAddress /> : <Login />}
        </Route>

        <Route exact path="/addaddress">
          {userData?._id ? <AddAddress /> : <Login />}
        </Route>

        <Route exact path="/editaddress/:id">
          {userData?._id ? <EditAddress /> : <Login />}
        </Route>

        <Route exact path="/checkout">
          {userData?._id ? <Checkout /> : <Login />}
        </Route>

        <Route exact path="/contact">
          <Contact />
        </Route>

        <Route exact path="/termcondition">
          <TermCondition />
        </Route>

        <Route exact path="/privacypolicy">
          <PrivacyPolicy />
        </Route>

        <Route exact path="/changepassword">
          {userData?._id ? <ChangePassword /> : <Login />}
        </Route>
        {/* <Route exact  path="/:username/register" component={SubscriptionForm} /> */}
        {/* <Route exact  path="/:username/login" component={Login} /> */}
        {/* <Route exact  path="/:username/view/:videoid" component={MovieView} /> */}


        {/* <Route exact path="/view/:slug">
          {subscription === null ? <Loader /> : <MovieView />}
        </Route> */}
        {/* <Route exact path="/view/:slug">
          {subscription === null ? <Loader /> : <MovieView />}
        </Route> */}
        {/* Optional: only subchannel page without video */}
        {/* <Route exact path="/:subchannelSlug/:slug">
          {subscription === null ? <Loader /> : <MovieView />}
        </Route>
        <Route exact path="/:MainChannel/:subChannel/:slug">
          {subscription === null ? <Loader /> : <MovieView />}
        </Route> */}



        {/* <Route exact path="/:MainChannel/:subChannel/:slug">
          {subscription === null ? <Loader /> : <MovieView />}
        </Route> */}

        {/* 2-segment video URL: /subchannel/video */}
        {/* <Route exact path="/:subChannel/:slug">
          {subscription === null ? <Loader /> : <MovieView />}
        </Route> */}




        {/* <Route exact path="/view/:videoid">
          {userData && userData._id ? (
            subscription ? (
              <MovieView />
            ) : subscription === false ? (
              <PaymentType />
            ) : (
              <Loader />
            )
          ) : userData === false ? (
            <Login />
          ) : (
            <Loader />
          )}
        </Route> */}




        {/* <Route exact path="/view/:videoid">
          {userData?._id ? (
            subscription ? <MovieView /> : <PaymentType />
          ) : <Login />}
        </Route> */}
        {/* <Route exact path="/:username/view/continue/:videoid/:time/:showid" > */}
        <Route exact path="/view/continue/:videoid/:time/:showid">
          {userData && userData._id ? (
            subscription ? (
              <ContinueViewPlay getCart={getCart} />
            ) : subscription === false ? (
              <PaymentType />
            ) : (
              <Loader />
            )
          ) : userData === false ? (
            <Login />
          ) : (
            <Loader />
          )}
        </Route>
        {/* <Route exact path="/view/continue/:videoid/:time/:showid">
          {userData?._id ? (
            subscription ? <ContinueViewPlay getCart={getCart} /> : <PaymentType />
          ) : <Login />}
        </Route> */}
        {/* <Route exact path="/:username/tvshowview/:showid" component={TvShows} /> */}
        <Route exact path="/tvshowview/:showid">
          {userData && userData._id ? (
            subscription ? (
              <TvShows />
            ) : subscription === false ? (
              <PaymentType />
            ) : (
              <Loader />
            )
          ) : userData === false ? (
            <Login />
          ) : (
            <Loader />
          )}
        </Route>
        {/* <Route exact path="/tvshowview/:showid">
          {userData?._id ? (
            subscription ? <TvShows /> : <PaymentType />
          ) : <Login />}
        </Route> */}
        {/* <Route exact  path="/:username/:videoid/play/:showid" component={PlayMovie} /> */}








        {/* <Route exact path="/:mainChannelName/:category/:slug/play">
          {subscription === null ? (
            <Loader />
          ) : (
            <PlayMovie getCart={getCart} />
          )}
        </Route>

        <Route exact path="/:category/:slug/play">
          {subscription === null ? (
            <Loader />
          ) : (
            <PlayMovie getCart={getCart} />
          )}
        </Route> */}








        {/* <Route exact path="/:category/:videoid/play">
          {userData && userData._id ? (
            subscription ? (
              <PlayMovie getCart={getCart} />
            ) : subscription === false ? (
              <PaymentType />
            ) : (
              <Loader />
            )
          ) : userData === false ? (
            <Login />
          ) : (
            <Loader />
          )}
        </Route> */}










        {/* <Route exact path="/:videoid/play/:showid">
          {userData?._id ? (
            subscription ? <PlayMovie getCart={getCart} /> : <PaymentType />
          ) : <Login />}
        </Route> */}




        {/* <Route exact path="/:username/tvshow/play/:showid/:videourl">
          {userData && userData._id ? (subscription ? <PlayTvShows /> : subscription === false ? <PaymentType /> : <Loader />) : userData === false ? <Login /> : <Loader />}
        </Route> */}
        <Route exact path="/tvshow/play/:showid/:videourl">
          {userData && userData._id ? (
            subscription ? (
              <PlayTvShows />
            ) : subscription === false ? (
              <PaymentType />
            ) : (
              <Loader />
            )
          ) : userData === false ? (
            <Login />
          ) : (
            <Loader />
          )}
        </Route>
        <Route exact path="/tvshow/play/:showid/:videourl">
          {userData?._id ? (
            subscription ? <PlayTvShows /> : <PaymentType />
          ) : <Login />}
        </Route>


        <Route
          exact

          path="/:username/details/payment"
          component={PaymentType}
        />


        <Route
          exact

          path="/:username/payment/:userid/:subscriptiontype/:stripeAccount"
          component={Payment}
        />

        <Route exact path="/subscription">
          {userData && userData._id ? (
            <PaymentType />
          ) : userData === false ? (
            <Login />
          ) : (
            <Loader />
          )}
        </Route>
        <Route exact path="/payment">
          {userData && userData._id ? (
            <Payment />
          ) : userData === false ? (
            <Login />
          ) : (
            <Loader />
          )}
        </Route>

        {/* <Route exact  path="/:username/search" component={Search} /> */}

        {/* <Route exact path="/subscription">
          {userData?._id ? <PaymentType /> : <Login />}
        </Route> */}

        {/* <Route exact path="/payment">
          {userData?._id ? <Payment /> : <Login />}
        </Route> */}
        <Route exact path="/search">
          {userData && userData._id ? (
            subscription ? (
              <Search />
            ) : subscription === false ? (
              <PaymentType />
            ) : (
              <Loader />
            )
          ) : userData === false ? (
            <Login />
          ) : (
            <Loader />
          )}
        </Route>
        {/* <Route exact path="/search">
          {userData?._id ? (
            subscription ? <Search /> : <PaymentType />
          ) : <Login />}
        </Route> */}

        <Route exact path="/register">
          {userData?._id ? <Redirect to="/" banner={homeBanners} /> : <SubscriptionForm />}
        </Route>

        <Route exact path="/login">
          {userData?._id ? <Redirect to="/" banner={homeBanners} /> : <Login />}
        </Route>
        <Route exact path="/forgot_password">
          {userData?._id ? <Redirect to="/" banner={homeBanners} /> : <ForgotPassword />}
        </Route>



        {/* Audeo Upload  */}
        <Route exact path="/audio_upload">
          <AudioUploader />
        </Route>
        {/* Audeo Upload  */}

        <Route exact path="/">
          <HomeContainer banner={homeBanners} />
        </Route>

        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </>

  );
};
export default Router;
